import { useSelector } from "react-redux";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link } from 'react-router-dom';




const CardMainSlider = (props) => {

    const { isMobile } = useSelector(state => state.general);

    return (

    	<div className="">
            <a className="block h-full w-full styles_MainHomeTopSliderItem__widget__lAr4S" target="_blank" href={props.data.url !== null && props.data.url !== "" ? props.data.url : '#'} onClick={(e) => {if(e.currentTarget.getAttribute('href') === '#'){e.preventDefault();}}}>
                <div>
                    <div className="user-select-none absolute z-1 top-0 w-full h-full styles_MainHomeTopSliderItem__image__d1__d" style={{borderRadius: '0px', lineHeight: '0'}}>
                        <picture>
                            <LazyLoadImage className="w-full h-full inline-block" src={props.data.image} alt={props.data.title} title={props.data.title} style={ isMobile ? {objectFit: 'cover', borderRadius: '20px'} : {objectFit: 'cover', borderRadius: '0px'} } />
                        </picture>
                    </div>
                </div>
            </a>
        </div>

    );
}

export default CardMainSlider;